// TODO : 추후 Product 의 Status 정보를 사용하는 곳에서 Constant를 사용하도록 코드를 수정해야 함.
// 관련 티켓 : https://gintlab.youtrack.cloud/agiles/121-20/current?issue=pvm-1069
export const ProductStatusConstant = {
  WAITING: 'WAITING',
  PENDING: 'PENDING',
  ONSALE: 'ONSALE',
  IN_CONTRACT: 'IN_CONTRACT',
  SOLDOUT: 'SOLDOUT',
} as const;

export const OpenMarketProductStatusConstant = {
  APPROVAL: 'APPROVAL',
  ONGOING: 'ONGOING',
  REJECT: 'REJECT',
} as const;

export const ProductCategoryConstant = {
  PLUVA: 'PLUVA',
  PARTNER: 'PARTNER',
  OPEN_MARKET: 'OPEN_MARKET',
} as const;

export const TIRE_CONDITION_OPTIONS: Record<string, TireConditionType> = {
  High: '상',
  Medium: '중',
  Low: '하',
};

export type ProductStatusType = keyof typeof ProductStatusConstant;
export type ProductCategoryType = keyof typeof ProductCategoryConstant;
export type OpenMarketProductStatusType = keyof typeof OpenMarketProductStatusConstant;
export type TireConditionType = '상' | '중' | '하';
